<template>
  <div class="">
    <base-menu :menu-position="menuPosition" id="menu-1"/>
  </div>
</template>

<script>
import {MenuProps} from './MenuProps'
import BaseMenu from "./BaseMenu";

export default {
  name: "Menu1",
  components: {BaseMenu},
  props: {
    ...MenuProps
  }
}
</script>

<style>
#menu-1 .dropdown-item {
  border-bottom: 1px solid rgba(217, 217, 217, 1);
  text-align: center;
}

#menu-1 .base-menu-item-wrapper {
  display: inline-block;
}

#menu-1 .base-menu-item {
  padding: 5px;
  transition: all ease-in-out .5s;
  font-weight: bold !important;
}

#menu-1 .base-menu-item, #menu-1 .dropdown-item {
  transition: all ease-in-out .5s;
  display: block;
}

#menu-1 .base-menu-item:hover, #menu-1 .dropdown-item:hover {
  background: var(--primary);
  border-radius: 15px;
  transition: all ease-in-out .5s;
  border: none;
  color: white !important;
  display: block;
}

</style>